import { Link } from 'gatsby';
import type { FC } from 'react';
import { AiFillInstagram } from '@react-icons/all-files/ai/AiFillInstagram';
import { FaFacebook } from '@react-icons/all-files/fa/FaFacebook';
import { FaLinkedinIn } from '@react-icons/all-files/fa/FaLinkedinIn';
import { FaYoutube } from '@react-icons/all-files/fa/FaYoutube';
import mapimg from '../../images/map.png';
import email from '../../images/email.png';
import mobile from '../../images/mobile.png';
import makeInIndia from '../../images/Make_In_India.png';
import arattailogo from '../../images/arattai_logo.png';
import googlePlayBadge from '../../images/Google_Play_Store.png';
import appStoreBadge from '../../images/Download_on_the_App_Store.png';

const FooterLinks: FC = () => {
  const playStoreUrl =
    'https://play.google.com/store/apps/details?id=com.sahilmachines.SahilCNCApp';
  const appStoreUrl = 'https://apps.apple.com/in/app/sahil-cnc/id6761299076';

  return (
    <div className="grid lg:grid-cols-5 lg:gap-10 py-10">
      <div>
        <p className="text-black text-lg font-bold uppercase mb-3">
          Quick Links
        </p>
        {footercmsPages.map(({ cmsPage, url }) => (
          <Link
            className="text-neutral-800 text-sm block pb-1.5"
            key={url}
            to={url}
          >
            {cmsPage}
          </Link>
        ))}
      </div>
      <div className="lg:col-span-2">
        <p className="text-black text-lg font-bold uppercase mb-3">PRODUCTS</p>
        <div className="grid grid-cols-2 gap-2">
          {productFooter.map(({ productName, url }) => (
            <Link
              className="text-neutral-800 text-sm"
              key={url}
              to={url}
            >
              {productName}
            </Link>
          ))}
        </div>
      </div>
      <div className="">
        <p className="text-black text-lg font-bold uppercase mb-3">
          Download the app
        </p>
        <div className="flex flex-col gap-3 pt-1 max-w-[180px]">
          <a
            className="inline-block leading-none"
            href={playStoreUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              alt="Get it on Google Play"
              className="h-auto w-full max-w-[180px]"
              src={googlePlayBadge}
            />
          </a>
          <a
            className="inline-block leading-none"
            href={appStoreUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              alt="Download on the App Store"
              className="h-auto w-full max-w-[180px]"
              src={appStoreBadge}
            />
          </a>
        </div>
      </div>
      <div>
        <div>
          <p className="text-black text-lg font-bold uppercase mb-3">Contact</p>
          <p className="text-neutral-800 text-sm flex pb-2">
            <i className="footer-icon">
              <img alt="Address" src={mapimg} />
            </i>{' '}
            8-B, Industrial Estate, Batala 143505
          </p>
          <a
            className="text-neutral-800 text-sm block flex pb-2"
            href="mailto:info@sahilcnc.com"
          >
            <i className="footer-icon">
              <img alt="Email" src={email} />
            </i>{' '}
            info@sahilcnc.com
          </a>
          <a
            className="text-neutral-800 text-sm block flex pb-2"
            href="mailto:sales@sahilcnc.com"
          >
            <i className="footer-icon">
              <img alt="Email" src={email} />
            </i>{' '}
            sales@sahilcnc.com
          </a>
          <a
            className="text-neutral-800 text-sm block flex pb-2"
            href="tel:+91-8427641925"
          >
            <i className="footer-icon">
              <img alt="Mobile" src={mobile} />
            </i>{' '}
            +91-8427641925
          </a>
        </div>

        <div className="flex space-x-3 items-center pt-2">
          <a
            className="text-black"
            href="https://www.linkedin.com/company/sahil-cnc-machines/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <FaLinkedinIn className="text-2xl fill-black" />
          </a>

          <a
            className="text-black"
            href="https://www.instagram.com/sahilcncmachines?igsh=MXVmODBueDZkM3Z1YQ=="
            rel="noopener noreferrer"
            target="_blank"
          >
            <AiFillInstagram className="text-2xl fill-black" />
          </a>
          <a
            className="text-black"
            href="https://www.facebook.com/profile.php?id=61556416797746&mibextid=ZbWKwL"
            rel="noopener noreferrer"
            target="_blank"
          >
            <FaFacebook className="text-2xl fill-black" />
          </a>
          <a
            className="text-black"
            href="https://www.youtube.com/@sahilcncmachines"
            rel="noopener noreferrer"
            target="_blank"
          >
            <FaYoutube className="text-2xl fill-black" />
          </a>
          <a
            className="text-black"
            href="https://aratt.ai/@sahilmachines"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img alt="Arattai" height={24} src={arattailogo} width={24} />
          </a>
        </div>
        <div className="flex flex-col justify-center items-center pt-6">
          <img
            alt="Make in India"
            className=""
            src={makeInIndia}
            width={180}
          />
        </div>
      </div>
    </div>
  );
};

export default FooterLinks;

const productFooter = [
  {
    productName: 'Conventional Vertical Turning Lathes',
    url: '/products/machines/turning-machines/vertical-turning-lathes/conventional-vertical/',
  },
  {
    productName: 'CNC Turret Vertical Turning Lathes',
    url: '/products/machines/turning-machines/vertical-turning-lathes/cnc-turret-vertical-turning-lathes/',
  },
  {
    productName: 'CNC Ram Type Vertical Turning Lathes',
    url: '/products/machines/turning-machines/vertical-turning-lathes/cnc-ram-type-vertical-turning/',
  },
  {
    productName: '3-Axis Double Column Milling Machines',
    url: '/products/machines/milling-machines/double-column-milling-machines/3-axis-double-column-milling-machines/',
  },
  {
    productName: '3-Axis CNC Gantry Milling Machines',
    url: '/products/machines/milling-machines/gantry-milling-machines/3-axis-cnc-gantry-milling-machines/',
  },
  {
    productName: 'CNC Horizontal Boring Machines',
    url: '/products/machines/boring-machines/horizontal-boring-machines/cnc-horizontal-boring-machines/',
  },
  {
    productName: 'CNC Floor Boring Machines',
    url: '/products/machines/boring-machines/floor-boring-machines/cnc-floor-boring-machines/',
  },
  {
    productName: 'Turret Type Vertical Turn Mill Machines',
    url: '/products/machines/turn-mill-machines/vertical-turn-mill-machines/turret-type-vertical-turn-mill-machines/',
  },
  {
    productName: 'Ram Type Vertical Turn Mill Machines',
    url: '/products/machines/turn-mill-machines/vertical-turn-mill-machines/ram-type-vertical-turn-mill-machines/',
  },
  {
    productName: 'CNC Slant Bed Turn Mill Machines',
    url: '/products/machines/turn-mill-machines/horizontal-turn-mill-machines/cnc-slant-bed-turn-mill-machines/',
  },
  {
    productName: '5-Axis Double Column Milling Machines',
    url: '/products/machines/milling-machines/double-column-milling-machines/5-axis-double-column-milling-machines/',
  },
  {
    productName: '5-Axis CNC Gantry Milling Machines',
    url: '/products/machines/milling-machines/gantry-milling-machines/5-axis-cnc-gantry-milling-machines/',
  },
  {
    productName: 'Cast Iron Floor Plates',
    url: '/products/machines/ci-castings/cast-iron-plates/floor-plate-series/',
  },
];

const footercmsPages = [
  {
    cmsPage: 'Blogs',
    url: '/blogs/1/',
  },
  {
    cmsPage: 'About Us',
    url: '/about/',
  },
  {
    cmsPage: 'Sales & Services',
    url: '/sales-and-services/',
  },
  {
    cmsPage: 'Services',
    url: '/industries/services/',
  },
  {
    cmsPage: 'Contact Us',
    url: '/contact-us/',
  },
  {
    cmsPage: 'Installation & Operator Training',
    url: '/industries/services/installation-operator-training/',
  },
  {
    cmsPage: 'Annual Maintenance Contract (AMC)',
    url: '/industries/services/annual-maintenance-contract/',
  },
  {
    cmsPage: 'Privacy Policy',
    url: '/privacy-policy/',
  },
  {
    cmsPage: 'Terms & Conditions',
    url: '/terms-and-conditions/',
  },
];
